// Libraries
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Table from './Table';
import FilterSection from './FiltersSection';

const Cell = ({ cell, userActions, data, pageType }) => {
    // console.log(cell, "data inside cell");
    if (cell.column.id.startsWith('action')){
        return <>{data ? userActions(data, cell) : '-'}</>;
    } else if (
        cell.column.header === 'Status' ||
        cell.column.header.includes('status')
    )
    {
        if (cell.value && cell.value !== '-') {
            let cellValue = cell.value;
            if (typeof cell.value === 'string' && !!cell.value) {
                cellValue = cell.value?.split('_')?.join(' ')?.toString();
            }
            return (
                <div
                    className={`status ${cell.value &&
                        cell.value.split(' ').join('')}`}
                    title={cell.value}
                >
                    {cellValue || '-'}
                </div>
            );
        }
        return (
            <span className="cell-text" title="-">
                -
            </span>
        );
    }
    else if (cell.column.id === 'label' || cell.column.id === 'clientLabel') {
        return (
            <span className="label-cell-text" title={cell.value}>
                {cell.value || '-'}
            </span>
        );
    }
    else if (cell.column.id === 'value') {
        return (
            <span className="value-cell-text" title={cell.value}>
                {cell.value || '-'}
            </span>
        );
    }
    else if(pageType === 'MerchantCheckerView')
    {
        return(
            <span className='clientValue-cell-text' title={cell.value} 
            style={
                cell?.column?.width
                    ? {
                        width: cell.column.width,
                        wordBreak: 'break-word', 
                        whiteSpace: 'normal',  
                    }
                    : {}
            }>
                {cell.value}
            </span>
        )
    }
    return (
        <span className="cell-text" title={cell.value}>
            {cell.value || cell.value === 0 ? cell.render('Cell') : '-'}
        </span>
    );

};

Cell.propTypes = {
    cell: PropTypes.object,
    userActions: PropTypes.func,
    data: PropTypes.object,
};

const TableWrap = ({
    columns,
    isFiltersEnable,
    isPaginationEnable,
    filterActionTitle,
    filterActionPermission,
    tableTitle,
    userActions,
    tableFilters,
    tableSearch,
    onClickTableAction,
    tableActionPopup,
    pageSizeOptions,
    paginationLabel,
    fetchData,
    data,
    loading,
    roleStatus,
    pageCount,
    pagePerView,
    additionalActions,
    tableSubSection,
    searchAction,
    error,
    isResetPage,
    afterResetPage,
    filterData,
    tableHead,
    id,
    tableSummary,
    isPGRepoTab,
    tableCard,
    emptyTitle,
    emptyDescription,
    pageType
}) => (
    <React.Fragment>
        <Table
            id={id}
            filter={
                <FilterSection
                    filterActionTitle={filterActionTitle}
                    filterActionPermission={filterActionPermission}
                    tableTitle={tableTitle}
                    tableFilters={tableFilters}
                    tableSearch={tableSearch}
                    onClickTableAction={onClickTableAction}
                    tableActionPopup={tableActionPopup}
                    additionalActions={additionalActions}
                    searchAction={searchAction}
                />
            }
            tableSubSection={tableSubSection}
            tableCell={(cell, userActions, row, pageType) => (
                <Cell cell={cell} userActions={userActions} data={row} pageType={pageType} />
            )}
            tableHead={tableHead}
            isFiltersEnable={isFiltersEnable}
            isPaginationEnable={
                isPaginationEnable && data && data.length > 0 && !error
            }
            pageSizeOptions={pageSizeOptions}
            paginationLabel={paginationLabel}
            roleStatus={roleStatus}
            columns={columns}
            data={data}
            fetchData={fetchData}
            loading={loading}
            pageCount={pageCount}
            userActions={userActions}
            pagePerView={pagePerView}
            error={error}
            isResetPage={isResetPage}
            afterResetPage={afterResetPage}
            filterData={filterData}
            tableSummary={tableSummary}
            tableTitle={tableTitle}
            isPGRepoTab={isPGRepoTab}
            tableCard={tableCard}
            emptyTitle={emptyTitle}
            emptyDescription={emptyDescription}
            pageType={pageType}
        />
    </React.Fragment>
);

TableWrap.propTypes = {
    additionalActions: PropTypes.node,
    searchAction: PropTypes.node,
    columns: PropTypes.array,
    data: PropTypes.array,
    fetchData: PropTypes.func,
    filterActionTitle: PropTypes.string,
    isFiltersEnable: PropTypes.bool,
    isPaginationEnable: PropTypes.bool,
    loading: PropTypes.bool,
    numberOfRecord: PropTypes.number,
    onClickTableAction: PropTypes.func,
    pageCount: PropTypes.number,
    pagePerView: PropTypes.number,
    pageSizeOptions: PropTypes.array,
    paginationLabel: PropTypes.string,
    roleStatus: PropTypes.string,
    setRoleStatus: PropTypes.func,
    tableActionPopup: PropTypes.node,
    tableFilters: PropTypes.node,
    tableSummary: PropTypes.node,
    tableSearch: PropTypes.node,
    tableSubSection: PropTypes.node,
    tableTitle: PropTypes.string,
    userActions: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    error: PropTypes.string,
    isResetPage: PropTypes.object,
    afterResetPage: PropTypes.func,
    filterData: PropTypes.object,
    tableHead: PropTypes.node,
    id: PropTypes.string,
    filterActionPermission: PropTypes.string,
    emptyTitle: PropTypes.string,
    emptyDescription: PropTypes.string,
};

TableWrap.defaultProps = {
    isFiltersEnable: false,
    isPaginationEnable: false,
    pagePerView: 5,
};

export default TableWrap;
